import { BaseModel } from '@/api/base-model'
import { CustomerPortalLinkAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'

export class CustomerPortalLink extends BaseModel<CustomerPortalLink> {
    protected collectionName = CustomerPortalLinkAPI.collectionName

    constructor(
        public id: string,
        public company: Company,
        public email: string,
    ) { super(id) }

    static fromData(data: any): CustomerPortalLink {
        if (data === null || typeof data === 'string' || data instanceof Comment) {
            return data
        }

        return new CustomerPortalLink(
            data.id,
            data.company ? Company.fromData(data.company) : null,
            data.email,
        )
    }
}
